import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { CommonStyle, ControlledTable, Filter2 } from "Components";
import { actionArr, FilterArr, TableCol } from "./Data";
import CommonFormatter from "Utils/Common.Formatter";
import { RouteUrls } from "Constant/RouteUrls";
import {
  HeaderInitialStateType,
  ScreenInitialStateType,
  UserInitialStateType
} from "DataTypes/Redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PreApprovedPlanApi from "Service/PreApprovedPlan.api";
import PreApprovedPlanFormatter from "Utils/PreApprovedPlan.Formatter";
import { PreApprovedPlanListType } from "DataTypes/PatientManagement.type";
import { TableLayout } from "Layouts";
import { Filter2DataProps } from "DataTypes/Common";
import {
  CreateFilter2Payload,
  RedoxDataToFilter,
  TransformFilterDataRedox
} from "Utils/common";
import { useDispatch } from "react-redux";
import UI from "Constant/UI";
import { setAlertData, setPageFilter, setPageLimit } from "Redux/Screen/Action";

const PreApprovedPlan: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { organization }: HeaderInitialStateType = useSelector(
    (state: any) => state?.header
  );
  const { listPagination, listFilters }: ScreenInitialStateType = useSelector(
    (state: any) => state?.screen
  );
  const { myInfo }: UserInitialStateType = useSelector(
    (state: any) => state?.user
  );
  const listObj = listFilters.find(el => el.id == "org-pre-approved-plan");
  const reduxLimit = (listPagination || []).find(
    el => el.id == "org-pre-approved-plan"
  )?.limit || 10;
  const [rows, setRows] = useState<PreApprovedPlanListType[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterHeight, setFilterHeight] = useState<number>(0);
  const [filterData, setFilterData] = useState<Filter2DataProps[]>(() =>
    RedoxDataToFilter(
      JSON.parse(JSON.stringify(FilterArr())),
      listObj
    )
  );
  const [pageData, setPageData] = useState({
    ...UI.pageData,
    limit: reduxLimit
  });
  const [searchText, setSearchText] = useState("");
  const tableHeight = `calc(100% - ${filterHeight}px)`;

  useEffect(() => {
    handleSetData(1, pageData.limit);
  }, [filterData, organization.id]);

  useEffect(() => {
    CommonFormatter.HandleNavArr({
      id: "pre-approved-plan",
      label: `${organization.name}'s Pre Approved Plans`,
      path: `/${RouteUrls.hs}/${RouteUrls.organization}` +
        `/${organization.id}/${RouteUrls.preApprovedPlan}/${RouteUrls.list}`,
      level: 2,
      link: RouteUrls.list,
      navType: "org",
    });
  }, [organization.id]);

  const handleSetData: (
    currentPage: number,
    currentLimit: number
  ) => void = async (currentPage, currentLimit) => {
    setLoading(true);
    const newFilterPayload = CreateFilter2Payload(filterData);
    const payload = {
      ...(newFilterPayload || {}),
      createdBy: null,
      practiceId: organization.id,
    };
    const res = await PreApprovedPlanApi.PlanList({
      offset: (currentPage - 1) * currentLimit,
      limit: currentLimit,
      data: payload
    });
    let newPageData = { ...UI.pageData }
    let newRows: PreApprovedPlanListType[] = [];
    if (res?.success) {
      newRows = PreApprovedPlanFormatter.PlanList(res?.data);
      newPageData = res.criterion
    }
    setRows(newRows);
    setPageData(newPageData)
    dispatch(setPageLimit({
      id: "org-pre-approved-plan",
      limit: newPageData.limit
    }));
    dispatch(setPageFilter({
      id: "org-pre-approved-plan",
      filterData: TransformFilterDataRedox(filterData)
    }));
    setLoading(false);
  }

  const handleView: (data: PreApprovedPlanListType) => void = (data) => {
    navigate(`../${data.planId}/${data.versionId}/${RouteUrls.plan}`);
  };

  const handleEnableDisable: (
    data: PreApprovedPlanListType
  ) => void = async (data) => {
    const payload = {
      planId: data.planId,
      planVersionId: data.versionId
    }
    const res = await PreApprovedPlanApi.TogglePlanStatus({
      data: payload
    });
    if (res?.success) {
      dispatch(setAlertData(res?.alert));
      handleSetData(pageData.page, pageData.limit);
    }
  };

  const TblBodyJSX = (
    <ControlledTable.TblBody
      tableColumn={() => TableCol()}
      tableRow={rows}
      tableAction={(data: PreApprovedPlanListType) =>
        actionArr(
          () => handleView(data),
          () => handleEnableDisable(data),
          data,
          myInfo.roleId
        )
      }
      searchText={searchText}
    />
  );

  return (
    <Box
      height="91%"
      sx={{
        ...CommonStyle.sxWhiteBox,
        overflow: "auto",
        px: 2
      }}
    >
      <Filter2
        filterDataArr={filterData}
        handleFilterClick={(data) => setFilterData(data)}
        changeSearchText={(val) => setSearchText(val)}
        setFilterHeight={(val) => setFilterHeight(val)}
      />
      <TableLayout
        tblBody={TblBodyJSX}
        tblHead={ControlledTable.TblHead(TableCol())}
        loading={loading}
        height={tableHeight}
        Pagination={
          <ControlledTable.Pagination
            mainPage={pageData.page}
            limit={pageData.limit}
            total={pageData.total}
            handleClick={handleSetData}
            tableStyle={true}
          />
        }
      />
    </Box>
  );
};
export default PreApprovedPlan;
